import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-582c00f0")

_pushScopeId("data-v-582c00f0")
const _hoisted_1 = { class: "pt-16 fixed inset-0 overflow-y-auto z-10 overflow-scroll" }
const _hoisted_2 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = { class: "z-0 text-sm bold text-bp-dark bg-gray-70 text-center\n     p-5 pt-2 pb-0" }
const _hoisted_4 = { class: "z-0 text-3xl bold text-bp-dark bg-gray-70 text-center\n     p-5 pt-2 pb-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DefaultButton = _resolveComponent("DefaultButton")
  const _component_btn_close = _resolveComponent("btn-close")
  const _component_default_button = _resolveComponent("default-button")
  const _component_DefaultCardLayout = _resolveComponent("DefaultCardLayout")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showButton === true)
      ? (_openBlock(), _createBlock(_component_DefaultButton, {
          key: 0,
          "button-text": _ctx.$t('profile.subscribed.btnCancelSubscription'),
          "button-color": "bg-gray-200",
          "button-width": "w-auto",
          "button-x-padding": "px-7",
          class: "order-last sm:order-first",
          onClick: _ctx.toggleDialog
        }, null, 8, ["button-text", "onClick"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode(_component_btn_close, {
            "btn-position": "mr-7",
            onClick: _ctx.cancelDialog
          }, null, 8, ["onClick"]),
          _createVNode(_component_DefaultCardLayout, { "card-padding": "px-6 md:px-1 mb-6" }, {
            default: _withId(() => [
              _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("profile.subscribed.cancelSubscriptionDetail")), 1),
              _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("profile.subscribed.boostpackName")), 1),
              _createVNode("form", {
                class: "space-y-10 mt-5",
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
              }, [
                _createVNode(_component_default_button, {
                  "button-text": _ctx.$t('btnCancelSubscription'),
                  "button-width": "w-auto",
                  "button-x-padding": "p-8"
                }, null, 8, ["button-text"])
              ], 32)
            ]),
            _: 1
          })
        ])
      ])
    ], 512), [
      [_vShow, _ctx.dialogVisible]
    ])
  ], 64))
})